import { IRootState } from '../types/IRootState';

const onlyClientItemsGetters = {
    getOnlyClientItems: (state: IRootState) => {
        return state.onlyClientItems;
    },
};
export default onlyClientItemsGetters;
